import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VDialog,
    {
      attrs: {
        fullscreen: _vm.$vuetify.breakpoint.mobile,
        width: _vm.dialogWidth,
        scrollable: "",
      },
      model: {
        value: _vm.showDialog,
        callback: function ($$v) {
          _vm.showDialog = $$v
        },
        expression: "showDialog",
      },
    },
    [
      _vm.showDialog
        ? _c(
            VCard,
            [
              _vm._t("title", function () {
                return [
                  _c(
                    VToolbar,
                    { attrs: { flat: "" } },
                    [
                      _c(VToolbarTitle, [
                        _c(
                          "span",
                          { staticClass: "px-2 text-h5 font-weight-bold" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("m1201.ReportDialog.header")) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(VSpacer),
                      _vm._v(" "),
                      _c(
                        VBtn,
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.showDialog = false
                            },
                          },
                        },
                        [_c(VIcon, [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              }),
              _vm._v(" "),
              _c(VCardTitle),
              _vm._v(" "),
              _c(
                VCardSubtitle,
                [
                  _vm._t("subtitle", function () {
                    return [
                      _c("div", { staticClass: "text-h6" }, [
                        _c("small", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("m1201.ReportDialog.sub_header", {
                                  type: _vm.$t(
                                    "m1201.ReportDialog.rel_models." +
                                      _vm.relModel
                                  ),
                                })
                              ) +
                              "\n          "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-subtitle-1 mt-3" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("m1201.ReportDialog.subtitle")) +
                            "\n        "
                        ),
                      ]),
                    ]
                  }),
                ],
                2
              ),
              _vm._v(" "),
              !_vm.showForm
                ? _c(
                    VCardText,
                    [
                      _c(
                        VList,
                        { attrs: { "three-line": "" } },
                        [
                          _c(
                            VListItemGroup,
                            {
                              attrs: { color: "primary" },
                              model: {
                                value: _vm.selectedIndex,
                                callback: function ($$v) {
                                  _vm.selectedIndex = $$v
                                },
                                expression: "selectedIndex",
                              },
                            },
                            [
                              _vm._l(_vm.categories, function (c, i) {
                                return [
                                  _c(
                                    VListItem,
                                    { key: `category-${i}` },
                                    [
                                      _c(
                                        VListItemAction,
                                        [
                                          _c(
                                            VRadioGroup,
                                            {
                                              model: {
                                                value: _vm.selectedIndex,
                                                callback: function ($$v) {
                                                  _vm.selectedIndex = $$v
                                                },
                                                expression: "selectedIndex",
                                              },
                                            },
                                            [
                                              _c(VRadio, {
                                                attrs: { value: i },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        VListItemContent,
                                        [
                                          _c(VListItemTitle, [
                                            _vm._v(
                                              _vm._s(c.translated_category_name)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(VListItemSubtitle, [
                                            _vm._v(
                                              _vm._s(c.translated_category_desc)
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  i < _vm.categories.length - 1
                                    ? _c(VDivider, { key: i })
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                VCardText,
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showForm,
                      expression: "showForm",
                    },
                  ],
                },
                [
                  _c(
                    VForm,
                    { staticClass: "py-2" },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { staticClass: "pb-0", attrs: { cols: "12" } },
                            [
                              _c(VTextarea, {
                                attrs: {
                                  counter: "",
                                  maxlength: "1000",
                                  outlined: "",
                                  label: _vm.$t(
                                    "m1201.ReportDialog.form.user_report_report"
                                  ),
                                },
                                model: {
                                  value: _vm.form.user_report_report,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "user_report_report",
                                      $$v
                                    )
                                  },
                                  expression: "form.user_report_report",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            VCol,
                            { staticClass: "pt-0", attrs: { cols: "12" } },
                            [
                              _c("label", { staticClass: "text-body-1" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "m1201.ReportDialog.form.attachments"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("AtFilePicker", {
                                attrs: {
                                  accept: "image/*",
                                  "max-files": "5",
                                  "max-file-size": "5MB",
                                },
                                on: {
                                  "upload-done": function ($event) {
                                    _vm.uploadDone = $event
                                  },
                                },
                                model: {
                                  value: _vm.form.attachments,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "attachments", $$v)
                                  },
                                  expression: "form.attachments",
                                },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-body-2" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "m1201.ReportDialog.form.attachments_rules"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                VCardActions,
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      !_vm.showForm
                        ? _c(
                            VBtn,
                            {
                              attrs: {
                                disabled: !_vm.form.m0601_id,
                                color: "primary",
                                block: "",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showForm = true
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t("m1201.ReportDialog.next_step")
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _c(
                            VBtn,
                            {
                              attrs: { color: "secondary", block: "" },
                              on: {
                                click: function ($event) {
                                  _vm.showForm = false
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("common.return")) +
                                  "\n        "
                              ),
                            ]
                          ),
                      _vm._v(" "),
                      _vm.showForm
                        ? _c(
                            VBtn,
                            {
                              staticClass: "mt-2",
                              attrs: {
                                disabled: !_vm.uploadDone,
                                color: "primary",
                                block: "",
                              },
                              on: { click: _vm.submit },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("common.submit")) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }